<!-- Modal -->
<div
  mdbModal
  #homeModal="mdb-modal"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="false"
  [config]="{ keyboard: false, ignoreBackdropClick: true }"
>
  <div [innerHTML]="commonService.getModalBackgroundImg('#FFF2E7')"></div>
  <div class="row m-0">
    <div class="col-md-2 p-0"></div>
    <div class="col-md-3 col-sm-12 p-0"></div>
    <div class="col-md-5 col-sm-12 p-0">
      <div class="modal-dialog home-modal-dialog">
        <div
          class="modal-content"
          [ngClass]="{
            'home-bg': [
              'CONNECTING',
              'REQUEST-ERROR',
              'CHAT-REJECT',
              'TRANSFER-REQUEST',
              'TRANSFERRING'
            ].includes(commonService.current.status)
          }"
        >
          <div class="modal-body p-0">
            <div
              class="d-flex flex-column h-100"
              *ngIf="commonService.current.status == 'SHOW-DETAILS'"
            >
              <div class="p-3 mt-2">
                <span
                  class="material-icons-outlined cursor"
                  (click)="homeModal.hide()"
                >
                  arrow_back
                </span>
              </div>
              <div class="row m-0 h-100 overflow-auto">
                <div class="col-md-2 p-0 mobile-hide"></div>
                <div class="col-sm-12 col-md-8 p-0">
                  <div class="peer-select-container">
                    <div class="peer-select-name pb-2">
                      {{ commonService.selectedPeer.displayName }}
                    </div>
                    <div class="app-sub-content pb-2">
                      <span *ngIf="commonService.selectedPeer.age">{{
                        commonService.selectedPeer.age
                      }}</span>
                      <span
                        *ngIf="
                          commonService.selectedPeer.age &&
                          (commonService.selectedPeer.gender ||
                            commonService.selectedPeer.sexuality)
                        "
                        >{{ "," }}&nbsp;</span
                      >
                      <span *ngIf="commonService.selectedPeer.gender">
                        {{ commonService.selectedPeer.gender }}</span
                      >
                      <span
                        *ngIf="
                          commonService.selectedPeer.gender &&
                          commonService.selectedPeer.sexuality
                        "
                        >{{ "," }}&nbsp;</span
                      >
                      <span *ngIf="commonService.selectedPeer.sexuality">{{
                        commonService.selectedPeer.sexuality
                      }}</span>
                    </div>
                    <div class="pb-3">
                      <span class="languages me-2">{{
                        commonService.selectedPeer.languages.join(", ")
                      }}</span>
                      <span class="city">{{
                        commonService.selectedPeer.city
                      }}</span>
                    </div>
                    <div class="peer-select-definition">
                      {{ "home.peerDefineContent" | translate }}
                    </div>
                    <img
                      class="peer-select-vector"
                      [src]="commonService.resource.image.peer_orange_vector"
                      alt=" "
                    />
                  </div>
                  <div class="user-details-card-container">
                    <img
                      class="user-card-vector"
                      [src]="commonService.resource.image.user_vector_border"
                      alt=""
                    />
                    <div class="user-details-content" style="z-index: 1">
                      <div class="user-message pb-3">
                        {{ "home.clientMessage" | translate }}
                      </div>
                      <input
                        type="text"
                        [ngClass]="{
                          'invalid-input': chatStartClicked && !userName
                        }"
                        class="form-control"
                        placeholder="Name"
                        [(ngModel)]="userName"
                        (ngModelChange)="chatStartClicked = false"
                        (keydown.enter)="startChat()"
                        maxlength="25"
                      />
                    </div>
                  </div>
                  <div class="px-2 py-4">
                    <button
                      mat-button
                      class="primary-button w-100"
                      (click)="startChat()"
                    >
                      {{ "home.startChat" | translate }}
                    </button>
                  </div>
                </div>
                <div class="col-md-2 p-0"></div>
              </div>
            </div>
            <ng-container
              class=" "
              *ngIf="
                ['CHAT-REJECT', 'REQUEST-ERROR', 'TRANSFER-FAILED'].includes(
                  commonService.current.status
                )
              "
            >
              <img
                class="bg-line position-fixed mobile-show"
                [src]="commonService.resource.image.modal_bg_line"
                alt=" "
              />
              <div class="row m-0" style="height: calc(100% - 25px)">
                <div class="col-md-2 p-0"></div>
                <div class="col-sm-12 col-md-8 pe-0 justify-content-center">
                  <div class="d-flex h-100 flex-column">
                    <div
                      class="d-flex justify-content-center text-center h-100 app-dialog-pos"
                    >
                      <div class="w-60">
                        <ng-container
                          *ngIf="
                            commonService.current.status != 'TRANSFER-FAILED'
                          "
                        >
                          <div
                            class="menu-header-content pb-2"
                            [innerHTML]="'home.requestError.title' | translate"
                          ></div>
                          <div class="app-sub-content">
                            <span
                              [innerHTML]="
                                'home.requestError.content' | translate
                              "
                            ></span>
                          </div>
                        </ng-container>
                        <ng-container
                          *ngIf="
                            commonService.current.status == 'TRANSFER-FAILED'
                          "
                        >
                          <div
                            class="menu-header-content pb-2"
                            [innerHTML]="
                              'home.transferRequestError.title' | translate
                            "
                          ></div>
                          <div class="app-sub-content">
                            <span
                              [innerHTML]="
                                'home.transferRequestError.content' | translate
                              "
                            ></span>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                    <div class="d-flex justify-content-center">
                      <img
                        class="p-4 cursor"
                        style="height: 120px"
                        [src]="commonService.resource.image.modal_close"
                        alt=" "
                        (click)="homeModal.hide()"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-2 p-0 mobile-hide"></div>
              </div>
            </ng-container>
            <ng-container *ngIf="commonService.current.status == 'CONNECTING'">
              <div
                class="app-heading font-14 cursor position-absolute m-2"
                (click)="homeModal.hide()"
              >
                <span class="material-icons-two-tone font-30">expand_more</span>
                hide
              </div>
              <img
                class="bg-line position-fixed mobile-show"
                [src]="commonService.resource.image.modal_bg_line"
                alt=" "
              />
              <div class="row m-0" style="height: calc(100% - 25px)">
                <div class="col-md-2 p-0"></div>
                <div class="col-sm-12 col-md-8 pe-0 justify-content-center">
                  <div class="d-flex h-100 flex-column">
                    <div
                      class="d-flex justify-content-center text-center h-100 app-dialog-pos"
                    >
                      <div class="w-60">
                        <div class="loader-container m-auto mb-4">
                          <span class="circle"></span>
                          <span class="circle"></span>
                          <span class="circle"></span>
                          <span class="circle"></span>
                        </div>
                        <div
                          class="menu-header-content"
                          [innerHTML]="'home.connecting.title' | translate"
                        ></div>
                        <div class="app-sub-content">
                          <span
                            [innerHTML]="'home.connecting.content' | translate"
                          ></span>
                        </div>
                        <!-- <div class="cancel-request" (click)="cancelRequest()">Cancel</div> -->
                      </div>
                    </div>
                    <div class="d-flex justify-content-center">
                      <img
                        class="p-4 cursor"
                        style="height: 120px"
                        [src]="commonService.resource.image.cancel"
                        alt=" "
                        (click)="cancelRequest()"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-2 p-0 mobile-hide"></div>
              </div>
            </ng-container>
            <ng-container
              *ngIf="commonService.current.status == 'TRANSFER-REQUEST'"
            >
              <img
                class="bg-line mobile-show position-fixed"
                [src]="commonService.resource.image.modal_bg_line"
                alt=" "
              />
              <div class="row m-0" style="height: calc(100% - 25px)">
                <div class="col-md-2 p-0"></div>
                <div
                  class="col-sm-12 col-md-8 pe-0 d-flex align-items-end justify-content-center"
                >
                  <div class="d-flex h-100 flex-column">
                    <div
                      class="d-flex justify-content-center text-center h-100 app-dialog-pos"
                    >
                      <div class="p-5">
                        <div
                          class="menu-header-content pb-3"
                          [innerHTML]="'home.transferRequest.title' | translate"
                        ></div>
                        <div class="app-sub-content">
                          <span
                            [innerHTML]="
                              'home.transferRequest.content' | translate
                            "
                          ></span>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex justify-content-center gap-3">
                      <button
                        mat-button
                        class="primary-button px-3"
                        (click)="transferRequestResponse('accept')"
                      >
                        {{ "home.transferRequest.transferAccept" | translate }}
                      </button>
                      <button
                        mat-button
                        class="secondary-button h-100"
                        (click)="transferRequestResponse('reject')"
                      >
                        {{ "home.transferRequest.transferCancel" | translate }}
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-2 p-0 mobile-hide"></div>
              </div>
            </ng-container>
            <ng-container
              *ngIf="commonService.current.status == 'TRANSFERRING'"
            >
              <img
                class="bg-line mobile-show position-fixed"
                [src]="commonService.resource.image.modal_bg_line"
                alt=" "
              />
              <div class="row m-0" style="height: calc(100% - 25px)">
                <div class="col-md-2 p-0"></div>
                <div
                  class="col-sm-12 col-md-8 pe-0 d-flex align-items-end justify-content-center"
                >
                  <div class="d-flex h-100 flex-column">
                    <div
                      class="d-flex justify-content-center text-center h-100 app-dialog-pos"
                    >
                      <div class="p-5">
                        <div class="loader-container m-auto mb-4">
                          <span class="circle"></span>
                          <span class="circle"></span>
                          <span class="circle"></span>
                          <span class="circle"></span>
                        </div>
                        <div
                          class="menu-header-content pb-3"
                          [innerHTML]="'home.transferring.title' | translate"
                        ></div>
                        <div class="app-sub-content">
                          <span
                            [innerHTML]="
                              'home.transferring.content' | translate
                            "
                          ></span>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex justify-content-center">
                      <img
                        class="p-4 cursor"
                        style="height: 110px; width: 90px"
                        [src]="commonService.resource.image.connection_hide"
                        alt=" "
                        (click)="homeModal.hide()"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-2 p-0 mobile-hide"></div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="col-md-2 p-0"></div>
    </div>
  </div>
</div>
